module.exports = __webpack_public_path__ + "img/cp-1.4c13e4b9.jpg";